import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import hospitalController from "../../../../../apis/Controllers/HospitalController/hospital.controller";

const HospitalDetailFunctions = () => {
    var breadcrumData = ["Dashboard", "Manage Hospital", "Hospital List"];
    var breadcrumItem = "View Hospital";

    const [taskAssign, setTaskAssign] = useState(false);
    const [hospitalDetail, setHospitalDetail] = useState(null);
    const [loader, setLoader] = useState(false);
    const loaction = useLocation();
    let navigate = useNavigate();


    const getHospitalDetail = async (id) => {
        setLoader(true);
        let response = await hospitalController.hospitalDetail(id);
        if (response && response.status) {
            setLoader(false);
            setHospitalDetail(response.data);
        }
        else {
            setLoader(false);
            setHospitalDetail(null);
        }
        setLoader(false);
    };

    return {
        getHospitalDetail,
        hospitalDetail,
        loader,
        loaction,
        navigate,
        taskAssign,
        setTaskAssign,
        breadcrumData,
        breadcrumItem,
        loader,
        setLoader
    }
};

export default HospitalDetailFunctions;